import { render } from "./ReviewPage.vue?vue&type=template&id=39a5515f&scoped=true"
import script from "./ReviewPage.vue?vue&type=script&lang=js"
export * from "./ReviewPage.vue?vue&type=script&lang=js"

import "./ReviewPage.vue?vue&type=style&index=0&id=39a5515f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a5515f"]])

export default __exports__